import { getCookie } from '../../service/cookieService';
import { getAuthToken } from '../appUtils';
import { getUserInfoFromServer } from '../getUserInfo';
import userUtils from '../userUtils';

export const getUUID = () => getCookie('MMYTUUID');

export const getLoginStatus = () => {
  const mmtAuth = getAuthToken();
  return mmtAuth != null ? (userUtils.isAgentLoggedin() ? 'seller' : 'user') : 'non-Loggedin';
};

export const getUserDetails = () => {
  const userInfo = getUserInfoFromServer();

  return userInfo?.email;
};
